import RMSRiskAssessmentContainer from "./RMSRiskAssessmentContainer";
import RMSRiskAssessmentStore from "./RMSRiskAssessmentStore";

export default RMSRiskAssessmentStore(RMSRiskAssessmentContainer);